module.exports = __webpack_public_path__ + "img/wrapbg2.1b0cdbe9.png";